import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-gray-100 dark:bg-gray-900">
      <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent dark:border-blue-300 dark:border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default LoadingSpinner;
